<template>
  <v-dialog
    v-if="showModalChallenge"
    v-model="showModalChallenge"
    :max-width="dialogWidth"
    overlay-color="bg-dark-overlay"
    overlay-opacity="0.5"
    content-class="no-shadow overflow-auto hide-scrollbar"
  >
    <v-card>
      <v-card-title class="custom_gray p-2">
        <v-container class="d-flex justify-content-between align-center py-1">
          <span>
            <span class="font-weight-bold">Desafio | Ciclo {{ selectedCycle.order }}</span> <span v-if="!isMobile">/</span> 
            <br v-if="isMobile">ID
            {{ challenge.id }} - {{ authUser.name }}
          </span>
          <i
            class="fas fa-times pointer-on-hover"
            @click="$emit('close')"
          />
        </v-container>
      </v-card-title>
      <v-divider class="m-0" />
      <v-container
        v-if="!isMobile"
        class="py-3 pb-0"
      >
        <Stepper
          v-model="activeTab"
          :active-tab="activeTab"
          :questions="questions"
        />
      </v-container>
      <v-container fluid>
        <v-row>
          <v-col
            :cols="12"
            :lg="4"
            :sm="12"
            :xs="12"
          >
            <MarkerComponent
              v-model="activeTab"
              :active-tab="activeTab"
              :challenge="challenge"
            />
            <v-card
              outlined
              rounded="sm"
              class="mt-4"
            >
              <v-card-title class="custom_gray font-weight-600 text-black">
                Alternativas
              </v-card-title>
              <v-divider class="m-0" />
              <v-card-text>
                <QuestionChoice
                  :question="currentQuestion"
                  :challenge="challenge"
                />
                <div class="d-flex justify-content-between p-3 flex-wrap">
                  <v-btn
                    color="nitro"
                    class="my-1"
                    small
                    outlined
                    @click="decrease"
                  >
                    <i class="fas fa-chevron-left align-middle" />
                    <span class="align-middle first-letter-capitalize">Questão anterior</span>
                  </v-btn>
                  <v-btn
                    color="nitro"
                    class="white--text my-1"
                    small
                    @click="increase"
                  >
                    <span class="align-middle first-letter-capitalize">Próxima questão</span>
                    <i class="fas fa-chevron-right align-middle" />
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            :cols="12"
            :lg="4"
            :sm="12"
            :xs="12"
          >
            <v-card
              rounded="sm"
              outlined
            >
              <v-card-title class="custom_gray font-weight-600 text-black">
                Questão {{ currentQuestion.key + 1 }}
              </v-card-title>
              <v-divider class="m-0" />
              <v-card-text>
                <div
                  class="mt-2 question-content"
                  style="max-height: 70vh; min-height: 65vh; overflow-y: auto"
                  v-html="currentQuestion.content"
                />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            :lg="4"
            :sm="12"
            :xs="12"
          >
            <v-card
              rounded="sm"
              outlined
            >
              <v-card-title class="custom_gray font-weight-600 text-black">
                Resolução
              </v-card-title>
              <v-divider class="m-0" />
              <v-card-text>
                <div
                  v-if="currentQuestion.resolutionImg"
                  style="max-height: 70vh; min-height: 65vh; overflow-y: auto"
                  class="mt-2 question-content"
                  v-html="currentQuestion.resolutionImg"
                />
                <div
                  v-else-if="currentQuestion.resolutionText"
                  style="max-height: 70vh; min-height: 65vh; overflow-y: auto"
                  class="mt-2 question-content"
                  v-html="currentQuestion.resolutionText"
                />
                <div
                  v-else
                  class="mt-2"
                >
                  Resolução não cadastrada
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>   
  </v-dialog>
</template>

<script>

import { mapActions, mapGetters, mapMutations } from 'vuex';
import BtnClose from '@/common/components/BtnClose'
import { defaultModalHeight } from '@/constants/general.js'
import MarkerComponent from '@/student/pages/cycle/components/challenge/MarkerComponent'
import Stepper from './Stepper.vue';
import QuestionChoice from './QuestionChoice.vue';

export default {
  components: {
    BtnClose,
    MarkerComponent,
    Stepper,
    QuestionChoice,
  },
  data() {
    return {
      defaultModalHeight
,      activeTab: 0,
    }
  },
   computed: {
    ...mapGetters(['selectedCycle','challenge','authUser']),
    questions() {
      return this.challenge.questions
    },
     dialogWidth(){
       switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100vw'
          case 'sm': return "90vw"
          case 'md': return "90vw"
          case 'lg': return "90vw"
          case 'xl': return "90vw"
          default : return '90vw'
        }
     },
    showModalChallenge: {
      get() {
        return this.$store.state.challenge.showModalChallenge;
      },
      set(value) {
        if(!value)
          this.SET_CHALLENGE();
        this.$store.commit('SHOW_MODAL_CHALLENGE', value);
      },
    },
    ...mapGetters(['current_cycle']),
    currentQuestion() {
      return this.questions[this.activeTab]
    },
  },
  methods:{
    ...mapMutations(['SHOW_MODAL_CHALLENGE']),
    ...mapActions(['accessChallenge']),
    onClose() {
      this.showModalChallenge = false;
    },
    increase() {
      this.activeTab += this.activeTab < this.questions.length - 1 ? 1 : 0
    },
    decrease() {
      this.activeTab -= this.activeTab > 0 ? 1 : 0
    },
  }
}
</script>
